<script setup lang="ts">
import { useInflectionTrainerWordClass } from "@/common/composables/use-inflection-trainer-word-class";
import SearchInfoBox from "@/components/article/SearchInfoBox.vue";
import type { WordClass } from "@/types/inflection-trainer.type";

const props = defineProps<{
  word: string;
  from: WordClass;
  to: WordClass;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { translatedWordClass: fromTranslated } = useInflectionTrainerWordClass(props.from);
const { translatedWordClass: toTranslated } = useInflectionTrainerWordClass(props.to);
</script>

<template>
  <SearchInfoBox class="word-class-switched-info-box" @close="emit('close')">
    <i18n-t keypath="inflection-trainer.word-class-switched-info-box">
      <template #word>
        <span class="word-class-switched-info-box__prominent-text">
          {{ word }}
        </span>
      </template>
      <template #from>
        <span
          class="word-class-switched-info-box__prominent-text word-class-switched-info-box__prominent-text--secondary"
        >
          {{ fromTranslated }}
        </span>
      </template>
      <template #to>
        <span
          class="word-class-switched-info-box__prominent-text word-class-switched-info-box__prominent-text--primary"
        >
          {{ toTranslated }}
        </span>
      </template>
    </i18n-t>
  </SearchInfoBox>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.word-class-switched-info-box {
  &__prominent-text {
    font-weight: 700;

    &--primary {
      color: rgb(@theme-colors[@primary][base]);
    }

    &--secondary {
      color: rgb(@theme-colors[@secondary][base]);
    }
  }
}
</style>
